import { render, staticRenderFns } from "./XlsImportErrors.vue?vue&type=template&id=01f68abf&"
import script from "./XlsImportErrors.vue?vue&type=script&lang=ts&"
export * from "./XlsImportErrors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports